import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PersonCircleOutlined } from "@common-packages/react-icons";
import "./ProfileName.scss";
import { AvinorColor } from "@constants";
import { useSignOut } from "@auth/hooks/useSignOut";
const ProfileName = () => {
    const { isAuthenticated, name } = useSignOut();
    return (_jsx(_Fragment, { children: isAuthenticated && (_jsxs("div", { className: "profile-name-wrapper", style: { display: "flex", justifyContent: "center", gap: "var(--avinor-spacing-2)" }, children: [_jsx(PersonCircleOutlined, { color: AvinorColor.HeaderTextSubtle, width: "1.5rem", height: "1.5rem" }), _jsx("span", { children: name })] })) }));
};
export default ProfileName;
